export interface AddCoachResponse {
  userName: string | null;
  userID: string | null;
  displayName: string | null;
  alias: string | null;
  owner: string | null;
  removable: boolean;
  relationToUser: string | null;
  messageCode: string;
}

export const EMPTY_ADD_COACH_RESPONSE: AddCoachResponse = {
  userName: '',
  userID: '',
  displayName: '',
  alias: '',
  owner: '',
  removable: true,
  relationToUser: '',
  messageCode: '',
};
